import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

@Component({
    selector: 'lc-modal-confirmation',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class ModalConfirmationComponent {
    @Input() header?: string;
    @Input() body?: string;
    @Input() confirmText: string = 'Confirmar';
    @Input() cancelText: string = 'Cancelar';
    @Input() confirmColor: 'success' | 'danger' = 'success';
    @Input() cancelColor: 'success' | 'danger' = 'danger';

    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    @ContentChild('modalHeader', { static: false }) modalHeaderTpl?: TemplateRef<any>;
    @ContentChild('modalBody', { static: false }) modalBodyTpl?: TemplateRef<any>;
    @ContentChild('modalFooter', { static: false }) modalFooterTpl?: TemplateRef<any>;

    isOpen = true;

    open() {
        this.isOpen = true;
        setTimeout(() => {
            const modal = document.getElementById('modal-content');
            modal?.focus();
        }, 0);
    }

    close() {
        this.isOpen = false;
        this.cancel.emit();
    }

    onEsc(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.close();
        }
    }

    onConfirm() {
        this.isOpen = false;
        this.confirm.emit();
    }

    onCancel() {
        this.isOpen = false;
        this.cancel.emit();
    }
}
